import { useLottiePlayer } from '@starsoft/common/hooks';
import { InfoProps } from './props';
import styles from './styles.module.scss';

/**
 * Info Component
 * A component that displays information with a Lottie animation, title and description
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.description - Description text to display
 * @param {string} props.lottie - Path to the Lottie animation file
 * @param {string} props.title - Title text to display
 * @returns {JSX.Element} Info component with animation, title and description
 *
 * @example
 * <Info
 *   description="This is an example description"
 *   lottie="/animations/example.json"
 *   title="Example Title"
 * />
 */
export function Info({ description, lottie, title }: InfoProps) {
  const { lottieAnimationRef } = useLottiePlayer({
    path: `/${lottie}`,
  });

  return (
    <div className={styles.container}>
      <div className={styles.container__lottie} ref={lottieAnimationRef} />
      <h6 className={styles.container__title}>{title}</h6>
      <p className={styles.container__description}>{description}</p>
    </div>
  );
}
